import script from "./OrdersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersPage.vue?vue&type=script&setup=true&lang=js"

import "./OrdersPage.vue?vue&type=style&index=0&id=2a6531a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a6531a7"]])

export default __exports__